import { UserTypes } from '@common/UserTypes';

import { UserDetails } from '../context/types';

export const isNewUser = (user: UserDetails) => {
  // Check if user was created within the last 10 minutes (10 * 60 * 1000 milliseconds)
  return !!(user.created && user.created >= Date.now() - 1000 * 60 * 10);
};

export enum UserRole {
  ClusterAdmin = UserTypes.ClusterAdmin,
  Support = UserTypes.Support,
  TeamAdmin = 'TeamAdmin',
  All = 'All'
}

/**
 * Checks if a user's role satisfies the required roles for an action
 * Support users always have access
 *
 * @param userRole - The user's current role
 * @param requiredRoles - Roles allowed to perform the action
 * @returns true if user has required permission
 */
export const hasRequiredRole = (userRole: UserRole, requiredRole: UserRole): boolean => {
  if (requiredRole === 'All') return true;

  // cluster admin and support users have access to everything
  if (userRole === UserRole.ClusterAdmin || userRole === UserRole.Support) return true;

  // only team admins/all cannot access everything
  if (userRole === requiredRole) return true;

  return false;
};
